const t="dls_ab_testing_id",o=()=>{const o=localStorage.getItem(t);if(!o){const o=Math.floor(100*Math.random()+1);return localStorage.setItem(t,o.toString()),o}return Number(o)};export{o as getABTestingKey};
//# sourceMappingURL=abTestingKey.js.map
